import { nanoid } from 'nanoid'
import { useEffect, useRef } from 'react'

import changeSet from 'core/change_set'

import { useDirtyState } from './hooks'

export const DirtyTracking = ({ formId, valuesMapper }) => {
  const id = useRef(formId || nanoid())
  const isDirty = useDirtyState(valuesMapper)
  useEffect(() => {
    if (isDirty) {
      changeSet.dirty(id.current)
    } else {
      changeSet.clear(id.current)
    }
  }, [isDirty])

  useEffect(() => () => changeSet.clear(id.current), [])

  return null
}
